import { render, staticRenderFns } from "./BaseSelect.vue?vue&type=template&id=060343a0&"
import script from "./BaseSelect.vue?vue&type=script&lang=ts&"
export * from "./BaseSelect.vue?vue&type=script&lang=ts&"
import style0 from "./BaseSelect.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import QSelect from 'quasar/src/components/select/QSelect.js';
import QMenu from 'quasar/src/components/menu/QMenu.js';
import QItem from 'quasar/src/components/item/QItem.js';
import QItemSection from 'quasar/src/components/item/QItemSection.js';
import QItemLabel from 'quasar/src/components/item/QItemLabel.js';
import QField from 'quasar/src/components/field/QField.js';
import qInstall from "../../../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QSelect,QMenu,QItem,QItemSection,QItemLabel,QField});
